<template>
    <div class="split-pane" 
        :style="gridStyle" 
        ref="container" 
        @mousemove="resizeHandler" 
        @mouseup="onMouseUp"
        @mouseleave="onMouseUp">
        <div class="pane">
            <slot name="left"></slot>
        </div>
        <div class="divider" @mousedown="onMouseDown"></div>
        <div class="pane">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
    name: "ResizePanel",
    props: {
        leftPaneWidth: {
            default: 20,
            type: Number
        }
    },
    setup(props) {
        let leftPaneWidthLocal = ref(20);
        let isResizing = ref(false);
        let container = ref(null);

        onMounted(() => {
            leftPaneWidthLocal.value = props.leftPaneWidth;
        })

        const gridStyle = computed(() => ({
            gridTemplateColumns: `${leftPaneWidthLocal.value}% 1% ${99 - leftPaneWidthLocal.value}%`
        }))

        const onMouseDown = () => {
            isResizing.value = true;
        }

        const onMouseUp = () => {
            isResizing.value = false;
        }

        const resizeHandler = (e) => {
            if (!isResizing.value || !container.value) return;

            const containerRect = container.value.getBoundingClientRect();
            const offsetX = e.clientX - containerRect.left;
            const newSize = parseInt(((offsetX / containerRect.width) * 100).toFixed(0));
            leftPaneWidthLocal.value = Math.min(80, Math.max(20, newSize));
        }

        return {
            gridStyle,
            container,
            resizeHandler,
            onMouseDown,
            onMouseUp
        };
    }
});
</script>

<style scoped>
.split-pane {
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-columns: 50% 1% 49%;
}

.divider {
    cursor: col-resize;
    /* width: 15px; */
    background: url('/images/divider.png') 50% 50% no-repeat;
}
</style>